(function (Drupal) {
  Drupal.behaviors.detailcardcontainer = {
    attach: function (context, settings) {
      const detailcardcontainer = context.querySelector(".paragraph--type--detailcardcontainer");
      if (detailcardcontainer) {
        const numberColumnsElement = detailcardcontainer.querySelector(".field--name-field-number-of-columns");
        if (numberColumnsElement) {
          const numberColumns = numberColumnsElement.textContent.trim().toLowerCase();
          detailcardcontainer.classList.add(`grid-template-${numberColumns}`);
        }
      }
    }
  }
})(Drupal);
